Object.defineProperty(exports, "__esModule", { value: true });
var math_1 = require("../utilities/math");
var distance_1 = require("../utilities/distance");
function perimeterPoints(pts) {
    var n = pts.length;
    var x2 = pts[n - 2];
    var y2 = pts[n - 1];
    var p = 0;
    for (var i = 0; i < n; i += 6) {
        p += distance_1.distance(pts[i], pts[i + 1], x2, y2);
        x2 = pts[i];
        y2 = pts[i + 1];
    }
    return math_1.floor(p);
}
exports.perimeterPoints = perimeterPoints;
